import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import * as CONSTANTS from '../constants';
import { ModalContext } from '../context/modal';

const Wrapper = styled.div`

`;

const GlobalStyle = createGlobalStyle`
  .light-theme .checkbox-label {
    ${props => (props.darkMode === true) ? `
    color: ${CONSTANTS.darkModeWhite} !important;
    ` : ''}
  }

  @-webkit-keyframes ripple {
      0% {
        opacity: 0;
        r: 0;
      }

      50% {
        opacity: .18;
        r: 120%;
      }

      100% {
        opacity: 0;
        r: 140%;
      }
  }

  @keyframes ripple {
      0% {
        opacity: 0;
        r: 0;
      }

      50% {
        opacity: .18;
        r: 120%;
      }
      
      100% {
        opacity: 0;
        r: 140%;
      }
  }

  .checkbox {
    align-items: center;
    cursor: pointer;
    display: inline-flex;
    justify-content: flex-start;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .checkbox-input {
    border: 0 !important;
    clip: rect(0 0 0 0) !important;
    height: 1px !important;
    margin: -1px !important;
    overflow: hidden !important;
    padding: 0 !important;
    position: absolute !important;
    width: 1px !important;
  }

  .light-theme .checkbox-input:disabled ~ .checkbox-indicator {
    border-color: rgba(0, 0, 0, 0.38);
  }

  .dark-theme .checkbox-input:disabled ~ .checkbox-indicator {
    border-color: rgba(255, 255, 255, 0.5);
  }

  .checkbox-input:disabled ~ .checkbox-indicator .checkbox-indicator-bg {
    fill: #B0B0B0;
  }

  .light-theme .checkbox-input:disabled ~ .checkbox-indicator .checkbox-indicator-bg {
    fill: rgba(0, 0, 0, 0.38);
  }

  .dark-theme .checkbox-input:disabled ~ .checkbox-indicator .checkbox-indicator-bg {
    fill: rgba(255, 255, 255, 0.5);
  }

  .checkbox-input:disabled ~ .checkbox-label {
    color: #B0B0B0;
  }

  .light-theme .checkbox-input:disabled ~ .checkbox-label {
    color: rgba(0, 0, 0, 0.38);
  }

  .dark-theme .checkbox-input:disabled ~ .checkbox-label {
    color: rgba(255, 255, 255, 0.5);
  }

  .checkbox-input:focus ~ .checkbox-indicator .checkbox-indicator-ripple {
    -webkit-animation: ripple 600ms;
    animation: ripple 600ms;
  }

  .checkbox-input:checked ~ .checkbox-indicator {
    border-color: #a3ffd3;
  }

  .checkbox-input:checked ~ .checkbox-indicator .checkbox-indicator-bg {
    height: 100%;
    width: 100%;
    opacity: 1;
    transition: 200ms ease-in-out opacity;
  }

  .checkbox-input:checked ~ .checkbox-indicator .checkbox-indicator-mark {
    stroke-dashoffset: 0;
  }

  .checkbox-input:required ~ .checkbox-label:after {
    content: '*';
  }

  .checkbox-indicator {
    height: 18px;
    width: 18px;
    border-color: #B0B0B0;
    border-radius: 5px;
    border-style: solid;
    border-width: 1px;
    overflow: visible !important;
  }

  .light-theme .checkbox-indicator {
    /*border-color: rgba(0, 0, 0, 0.54);*/
    border-color: #ccc;
  }

  .dark-theme .checkbox-indicator {
    border-color: rgba(255, 255, 255, 0.7);
  }

  .checkbox-indicator-round {
    border-radius: 50%;
  }

  .checkbox-indicator-round .checkbox-indicator-bg {
    cx: 50%;
    cy: 50%;
    r: 50%;
  }

  .checkbox-indicator-bg {
    height: 0;
    width: 0;
    fill: #a3ffd3;
    opacity: 0;
    transition: 250ms ease-in-out opacity;
    will-change: opacity;
  }

  .checkbox-indicator-mark {
    fill: none;
    stroke: ${CONSTANTS.darkGray};
    stroke-width: 2;
    transition: 300ms linear stroke-dashoffset;
  }

  .light-theme .checkbox-indicator-mark {
    stroke: ${CONSTANTS.darkGray};
  }
  
  .dark-theme .checkbox-indicator-mark {
    stroke: #fff;
  }

  .checkbox-indicator-ripple {
    fill: #a3ffd3;
    cx: 50%;
    cy: 50%;
    will-change: opacity, r;
  }

  .checkbox-label {
    padding: 0 10px;
    font-size: 13px;
    line-height: 18px;
    font-weight: 200;
  }

  .light-theme .checkbox-label {
    color: #2f2f2f;
  }

  .dark-theme .checkbox-label {
    color: #fff;
  }
`;

let nextId = 0;

function getNextId(prefix = 'element') {
  return `${prefix}-${nextId++}`;
}

const CheckboxIndicator = ({ round }) => {
  const markLength = 15.749618530273438;

  return (
    React.createElement("svg", { viewBox: "0 0 16 16", className: `checkbox-indicator ${round && 'checkbox-indicator-round'}` },
    
    round ?
      React.createElement("circle", { className: "checkbox-indicator-bg" }) :
      React.createElement("rect", { className: "checkbox-indicator-bg" }),

      React.createElement("circle", { className: "checkbox-indicator-ripple" }),
      React.createElement("path", { className: "checkbox-indicator-mark jsMark", transform: "translate(1, 2)", strokeDashoffset: markLength, strokeDasharray: markLength, d: "M1.42420783 6.03075103 5.00322799 9.5725669 12.5960318 2.01301652" }))
  );
};

const CheckboxLabel = ({ label }) =>
  label && React.createElement("span", { className: "checkbox-label" }, label);


const Checkboxxx = ({ required, disabled, name, checked, label, value, round, onChange = () => {} }) => {
  const elementId = getNextId(),
  isDisabled = disabled ? 'disabled' : false,
  isRequired = required ? 'required' : false,
  isChecked = checked ? 'checked' : false;

  return (
    React.createElement("label", { className: "checkbox", htmlFor: elementId },
    React.createElement("input", {
      onChange: onChange,
      className: "checkbox-input",
      type: "checkbox",
      name: name,
      value: value,
      required: isRequired,
      disabled: isDisabled,
      defaultChecked: isChecked,
      id: elementId }),
    React.createElement(CheckboxIndicator, { round: round }),
    React.createElement(CheckboxLabel, { label: label }))
  );
};

export default class Checkbox extends React.Component {
  constructor(props) {
    super(props);
  }

  render () {
    const element = React.createElement(Checkboxxx, { label: this.props.labelText, checked: this.props.isChecked, round: this.props.isRound });

    return (
      <Wrapper id={this.props.id} darkMode={this.context.darkMode} className="light-theme">
        <GlobalStyle darkMode={this.context.darkMode} />
        {element}
      </Wrapper>
    );
  }
}

Checkbox.contextType = ModalContext;
